class Answer {
    constructor(answer = {}) {
        this.QuestionId = answer?.QuestionId || ''
        this.AnswerId = answer?.AnswerId || ''
        this.AnswerValue = answer?.AnswerValue || ''
    }
}

export default Answer;